// @flow

import React from 'react';
import { Container } from 'reactstrap';
import {
    getJsonRequestBody,
    jsonGetRequest,
    jsonPostRequest,
    jsonPutRequest,
} from '../../store/requests';
import MenuCatalogManager from './MenuCatalogManager';

const DEMO_LOCATION_ID = 'org_location-d4bb19d9f0cb';

function backofficeMenuApi() {
    return {
        listLocations: () =>
            jsonGetRequest(
                `organizations/locations?pagination=${encodeURIComponent(JSON.stringify({ page: 1, perPage: 100 }))}`,
            ),
        getCatalog: (locationId: string) => jsonGetRequest(`organizations/locations/${locationId}/menu-catalog`),
        saveDraft: (locationId: string, draft: any, sourceUrl?: string) =>
            jsonPutRequest(
                `organizations/locations/${locationId}/menu-catalog`,
                getJsonRequestBody({ draft, source_url: sourceUrl || null }),
            ),
        importFromUrl: (locationId: string, url: string) =>
            jsonPostRequest(
                `organizations/locations/${locationId}/menu-catalog/import`,
                getJsonRequestBody({ url }),
            ),
        publish: (locationId: string, force?: boolean) =>
            jsonPostRequest(
                `organizations/locations/${locationId}/menu-catalog/publish`,
                getJsonRequestBody({ force: !!force }),
            ),
        resync: (locationId: string, url?: string) =>
            jsonPostRequest(
                `organizations/locations/${locationId}/menu-catalog/resync`,
                getJsonRequestBody(url ? { url } : {}),
            ),
        seedDemo: (locationId: string) =>
            jsonPostRequest(
                `organizations/locations/${locationId}/menu-catalog/seed-demo`,
                getJsonRequestBody({ force: locationId !== DEMO_LOCATION_ID }),
            ),
    };
}

export default function MenuCatalogDashboard() {
    return (
        <Container className="py-4" data-testid="menu-catalog-dashboard">
            <MenuCatalogManager
                api={backofficeMenuApi()}
                title="Menu catalog (ops)"
                allowSeedDemo
                initialLocationId={DEMO_LOCATION_ID}
            />
        </Container>
    );
}
